export const defaultAgeGroup = {
    ageGroupName: '',
    ageStart: 0,
    ageEnd: 0,
    ageStartMonths: 0,
    ageEndMonths: 0,
    comments: '',
}
